/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/_signup'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StartIndexRouteImport } from './routes/start/index'
import { Route as OpportunityIndexRouteImport } from './routes/opportunity/index'
import { Route as StartOthersRouteImport } from './routes/start/others'
import { Route as StartBusinessTypeRouteImport } from './routes/start/$businessType'
import { Route as SignupSuccessRouteImport } from './routes/_signup/success'
import { Route as SignupPricingRouteImport } from './routes/_signup/pricing'
import { Route as SignupEmailValidationRouteImport } from './routes/_signup/email-validation'
import { Route as SignupActivitiesRouteImport } from './routes/_signup/activities'
import { Route as OpportunityOppIdRouteRouteImport } from './routes/opportunity/$oppId/route'
import { Route as SignupStatusIndexRouteImport } from './routes/_signup/status/index'
import { Route as SignupOfferIndexRouteImport } from './routes/_signup/offer/index'
import { Route as SignupGymIndexRouteImport } from './routes/_signup/gym/index'
import { Route as SignupStatusStatusScreenRouteImport } from './routes/_signup/status/$statusScreen'
import { Route as SignupGymTaxDetailsRouteImport } from './routes/_signup/gym/tax-details'
import { Route as SignupGymBusinessDetailsRouteImport } from './routes/_signup/gym/business-details'
import { Route as OpportunityOppIdTermsAndConditionsIndexRouteImport } from './routes/opportunity/$oppId/terms-and-conditions/index'
import { Route as OpportunityOppIdSuccessIndexRouteImport } from './routes/opportunity/$oppId/success/index'
import { Route as OpportunityOppIdEmailValidationIndexRouteImport } from './routes/opportunity/$oppId/email-validation/index'
import { Route as SignupOfferDeclineIndexRouteImport } from './routes/_signup/offer/decline/index'
import { Route as OpportunityOppIdTermsAndConditionsDeclineIndexRouteImport } from './routes/opportunity/$oppId/terms-and-conditions/decline/index'
import { Route as OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRouteImport } from './routes/opportunity/$oppId/terms-and-conditions/decline/success/index'

const SignupRoute = SignupRouteImport.update({
  id: '/_signup',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StartIndexRoute = StartIndexRouteImport.update({
  id: '/start/',
  path: '/start/',
  getParentRoute: () => rootRouteImport,
} as any)
const OpportunityIndexRoute = OpportunityIndexRouteImport.update({
  id: '/opportunity/',
  path: '/opportunity/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/opportunity/index.lazy').then((d) => d.Route),
)
const StartOthersRoute = StartOthersRouteImport.update({
  id: '/start/others',
  path: '/start/others',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/start/others.lazy').then((d) => d.Route))
const StartBusinessTypeRoute = StartBusinessTypeRouteImport.update({
  id: '/start/$businessType',
  path: '/start/$businessType',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/start/$businessType.lazy').then((d) => d.Route),
)
const SignupSuccessRoute = SignupSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => SignupRoute,
} as any).lazy(() =>
  import('./routes/_signup/success.lazy').then((d) => d.Route),
)
const SignupPricingRoute = SignupPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => SignupRoute,
} as any).lazy(() =>
  import('./routes/_signup/pricing.lazy').then((d) => d.Route),
)
const SignupEmailValidationRoute = SignupEmailValidationRouteImport.update({
  id: '/email-validation',
  path: '/email-validation',
  getParentRoute: () => SignupRoute,
} as any).lazy(() =>
  import('./routes/_signup/email-validation.lazy').then((d) => d.Route),
)
const SignupActivitiesRoute = SignupActivitiesRouteImport.update({
  id: '/activities',
  path: '/activities',
  getParentRoute: () => SignupRoute,
} as any).lazy(() =>
  import('./routes/_signup/activities.lazy').then((d) => d.Route),
)
const OpportunityOppIdRouteRoute = OpportunityOppIdRouteRouteImport.update({
  id: '/opportunity/$oppId',
  path: '/opportunity/$oppId',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupStatusIndexRoute = SignupStatusIndexRouteImport.update({
  id: '/status/',
  path: '/status/',
  getParentRoute: () => SignupRoute,
} as any)
const SignupOfferIndexRoute = SignupOfferIndexRouteImport.update({
  id: '/offer/',
  path: '/offer/',
  getParentRoute: () => SignupRoute,
} as any).lazy(() =>
  import('./routes/_signup/offer/index.lazy').then((d) => d.Route),
)
const SignupGymIndexRoute = SignupGymIndexRouteImport.update({
  id: '/gym/',
  path: '/gym/',
  getParentRoute: () => SignupRoute,
} as any)
const SignupStatusStatusScreenRoute =
  SignupStatusStatusScreenRouteImport.update({
    id: '/status/$statusScreen',
    path: '/status/$statusScreen',
    getParentRoute: () => SignupRoute,
  } as any).lazy(() =>
    import('./routes/_signup/status/$statusScreen.lazy').then((d) => d.Route),
  )
const SignupGymTaxDetailsRoute = SignupGymTaxDetailsRouteImport.update({
  id: '/gym/tax-details',
  path: '/gym/tax-details',
  getParentRoute: () => SignupRoute,
} as any).lazy(() =>
  import('./routes/_signup/gym/tax-details.lazy').then((d) => d.Route),
)
const SignupGymBusinessDetailsRoute =
  SignupGymBusinessDetailsRouteImport.update({
    id: '/gym/business-details',
    path: '/gym/business-details',
    getParentRoute: () => SignupRoute,
  } as any).lazy(() =>
    import('./routes/_signup/gym/business-details.lazy').then((d) => d.Route),
  )
const OpportunityOppIdTermsAndConditionsIndexRoute =
  OpportunityOppIdTermsAndConditionsIndexRouteImport.update({
    id: '/terms-and-conditions/',
    path: '/terms-and-conditions/',
    getParentRoute: () => OpportunityOppIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/opportunity/$oppId/terms-and-conditions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const OpportunityOppIdSuccessIndexRoute =
  OpportunityOppIdSuccessIndexRouteImport.update({
    id: '/success/',
    path: '/success/',
    getParentRoute: () => OpportunityOppIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/opportunity/$oppId/success/index.lazy').then(
      (d) => d.Route,
    ),
  )
const OpportunityOppIdEmailValidationIndexRoute =
  OpportunityOppIdEmailValidationIndexRouteImport.update({
    id: '/email-validation/',
    path: '/email-validation/',
    getParentRoute: () => OpportunityOppIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/opportunity/$oppId/email-validation/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SignupOfferDeclineIndexRoute = SignupOfferDeclineIndexRouteImport.update({
  id: '/offer/decline/',
  path: '/offer/decline/',
  getParentRoute: () => SignupRoute,
} as any).lazy(() =>
  import('./routes/_signup/offer/decline/index.lazy').then((d) => d.Route),
)
const OpportunityOppIdTermsAndConditionsDeclineIndexRoute =
  OpportunityOppIdTermsAndConditionsDeclineIndexRouteImport.update({
    id: '/terms-and-conditions/decline/',
    path: '/terms-and-conditions/decline/',
    getParentRoute: () => OpportunityOppIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/opportunity/$oppId/terms-and-conditions/decline/index.lazy'
    ).then((d) => d.Route),
  )
const OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRoute =
  OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRouteImport.update({
    id: '/terms-and-conditions/decline/success/',
    path: '/terms-and-conditions/decline/success/',
    getParentRoute: () => OpportunityOppIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/opportunity/$oppId/terms-and-conditions/decline/success/index.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/opportunity/$oppId': typeof OpportunityOppIdRouteRouteWithChildren
  '/activities': typeof SignupActivitiesRoute
  '/email-validation': typeof SignupEmailValidationRoute
  '/pricing': typeof SignupPricingRoute
  '/success': typeof SignupSuccessRoute
  '/start/$businessType': typeof StartBusinessTypeRoute
  '/start/others': typeof StartOthersRoute
  '/opportunity': typeof OpportunityIndexRoute
  '/start': typeof StartIndexRoute
  '/gym/business-details': typeof SignupGymBusinessDetailsRoute
  '/gym/tax-details': typeof SignupGymTaxDetailsRoute
  '/status/$statusScreen': typeof SignupStatusStatusScreenRoute
  '/gym': typeof SignupGymIndexRoute
  '/offer': typeof SignupOfferIndexRoute
  '/status': typeof SignupStatusIndexRoute
  '/offer/decline': typeof SignupOfferDeclineIndexRoute
  '/opportunity/$oppId/email-validation': typeof OpportunityOppIdEmailValidationIndexRoute
  '/opportunity/$oppId/success': typeof OpportunityOppIdSuccessIndexRoute
  '/opportunity/$oppId/terms-and-conditions': typeof OpportunityOppIdTermsAndConditionsIndexRoute
  '/opportunity/$oppId/terms-and-conditions/decline': typeof OpportunityOppIdTermsAndConditionsDeclineIndexRoute
  '/opportunity/$oppId/terms-and-conditions/decline/success': typeof OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/opportunity/$oppId': typeof OpportunityOppIdRouteRouteWithChildren
  '/activities': typeof SignupActivitiesRoute
  '/email-validation': typeof SignupEmailValidationRoute
  '/pricing': typeof SignupPricingRoute
  '/success': typeof SignupSuccessRoute
  '/start/$businessType': typeof StartBusinessTypeRoute
  '/start/others': typeof StartOthersRoute
  '/opportunity': typeof OpportunityIndexRoute
  '/start': typeof StartIndexRoute
  '/gym/business-details': typeof SignupGymBusinessDetailsRoute
  '/gym/tax-details': typeof SignupGymTaxDetailsRoute
  '/status/$statusScreen': typeof SignupStatusStatusScreenRoute
  '/gym': typeof SignupGymIndexRoute
  '/offer': typeof SignupOfferIndexRoute
  '/status': typeof SignupStatusIndexRoute
  '/offer/decline': typeof SignupOfferDeclineIndexRoute
  '/opportunity/$oppId/email-validation': typeof OpportunityOppIdEmailValidationIndexRoute
  '/opportunity/$oppId/success': typeof OpportunityOppIdSuccessIndexRoute
  '/opportunity/$oppId/terms-and-conditions': typeof OpportunityOppIdTermsAndConditionsIndexRoute
  '/opportunity/$oppId/terms-and-conditions/decline': typeof OpportunityOppIdTermsAndConditionsDeclineIndexRoute
  '/opportunity/$oppId/terms-and-conditions/decline/success': typeof OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_signup': typeof SignupRouteWithChildren
  '/opportunity/$oppId': typeof OpportunityOppIdRouteRouteWithChildren
  '/_signup/activities': typeof SignupActivitiesRoute
  '/_signup/email-validation': typeof SignupEmailValidationRoute
  '/_signup/pricing': typeof SignupPricingRoute
  '/_signup/success': typeof SignupSuccessRoute
  '/start/$businessType': typeof StartBusinessTypeRoute
  '/start/others': typeof StartOthersRoute
  '/opportunity/': typeof OpportunityIndexRoute
  '/start/': typeof StartIndexRoute
  '/_signup/gym/business-details': typeof SignupGymBusinessDetailsRoute
  '/_signup/gym/tax-details': typeof SignupGymTaxDetailsRoute
  '/_signup/status/$statusScreen': typeof SignupStatusStatusScreenRoute
  '/_signup/gym/': typeof SignupGymIndexRoute
  '/_signup/offer/': typeof SignupOfferIndexRoute
  '/_signup/status/': typeof SignupStatusIndexRoute
  '/_signup/offer/decline/': typeof SignupOfferDeclineIndexRoute
  '/opportunity/$oppId/email-validation/': typeof OpportunityOppIdEmailValidationIndexRoute
  '/opportunity/$oppId/success/': typeof OpportunityOppIdSuccessIndexRoute
  '/opportunity/$oppId/terms-and-conditions/': typeof OpportunityOppIdTermsAndConditionsIndexRoute
  '/opportunity/$oppId/terms-and-conditions/decline/': typeof OpportunityOppIdTermsAndConditionsDeclineIndexRoute
  '/opportunity/$oppId/terms-and-conditions/decline/success/': typeof OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/opportunity/$oppId'
    | '/activities'
    | '/email-validation'
    | '/pricing'
    | '/success'
    | '/start/$businessType'
    | '/start/others'
    | '/opportunity'
    | '/start'
    | '/gym/business-details'
    | '/gym/tax-details'
    | '/status/$statusScreen'
    | '/gym'
    | '/offer'
    | '/status'
    | '/offer/decline'
    | '/opportunity/$oppId/email-validation'
    | '/opportunity/$oppId/success'
    | '/opportunity/$oppId/terms-and-conditions'
    | '/opportunity/$oppId/terms-and-conditions/decline'
    | '/opportunity/$oppId/terms-and-conditions/decline/success'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/opportunity/$oppId'
    | '/activities'
    | '/email-validation'
    | '/pricing'
    | '/success'
    | '/start/$businessType'
    | '/start/others'
    | '/opportunity'
    | '/start'
    | '/gym/business-details'
    | '/gym/tax-details'
    | '/status/$statusScreen'
    | '/gym'
    | '/offer'
    | '/status'
    | '/offer/decline'
    | '/opportunity/$oppId/email-validation'
    | '/opportunity/$oppId/success'
    | '/opportunity/$oppId/terms-and-conditions'
    | '/opportunity/$oppId/terms-and-conditions/decline'
    | '/opportunity/$oppId/terms-and-conditions/decline/success'
  id:
    | '__root__'
    | '/'
    | '/_signup'
    | '/opportunity/$oppId'
    | '/_signup/activities'
    | '/_signup/email-validation'
    | '/_signup/pricing'
    | '/_signup/success'
    | '/start/$businessType'
    | '/start/others'
    | '/opportunity/'
    | '/start/'
    | '/_signup/gym/business-details'
    | '/_signup/gym/tax-details'
    | '/_signup/status/$statusScreen'
    | '/_signup/gym/'
    | '/_signup/offer/'
    | '/_signup/status/'
    | '/_signup/offer/decline/'
    | '/opportunity/$oppId/email-validation/'
    | '/opportunity/$oppId/success/'
    | '/opportunity/$oppId/terms-and-conditions/'
    | '/opportunity/$oppId/terms-and-conditions/decline/'
    | '/opportunity/$oppId/terms-and-conditions/decline/success/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SignupRoute: typeof SignupRouteWithChildren
  OpportunityOppIdRouteRoute: typeof OpportunityOppIdRouteRouteWithChildren
  StartBusinessTypeRoute: typeof StartBusinessTypeRoute
  StartOthersRoute: typeof StartOthersRoute
  OpportunityIndexRoute: typeof OpportunityIndexRoute
  StartIndexRoute: typeof StartIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_signup': {
      id: '/_signup'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start/': {
      id: '/start/'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opportunity/': {
      id: '/opportunity/'
      path: '/opportunity'
      fullPath: '/opportunity'
      preLoaderRoute: typeof OpportunityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start/others': {
      id: '/start/others'
      path: '/start/others'
      fullPath: '/start/others'
      preLoaderRoute: typeof StartOthersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start/$businessType': {
      id: '/start/$businessType'
      path: '/start/$businessType'
      fullPath: '/start/$businessType'
      preLoaderRoute: typeof StartBusinessTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_signup/success': {
      id: '/_signup/success'
      path: '/success'
      fullPath: '/success'
      preLoaderRoute: typeof SignupSuccessRouteImport
      parentRoute: typeof SignupRoute
    }
    '/_signup/pricing': {
      id: '/_signup/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof SignupPricingRouteImport
      parentRoute: typeof SignupRoute
    }
    '/_signup/email-validation': {
      id: '/_signup/email-validation'
      path: '/email-validation'
      fullPath: '/email-validation'
      preLoaderRoute: typeof SignupEmailValidationRouteImport
      parentRoute: typeof SignupRoute
    }
    '/_signup/activities': {
      id: '/_signup/activities'
      path: '/activities'
      fullPath: '/activities'
      preLoaderRoute: typeof SignupActivitiesRouteImport
      parentRoute: typeof SignupRoute
    }
    '/opportunity/$oppId': {
      id: '/opportunity/$oppId'
      path: '/opportunity/$oppId'
      fullPath: '/opportunity/$oppId'
      preLoaderRoute: typeof OpportunityOppIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_signup/status/': {
      id: '/_signup/status/'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof SignupStatusIndexRouteImport
      parentRoute: typeof SignupRoute
    }
    '/_signup/offer/': {
      id: '/_signup/offer/'
      path: '/offer'
      fullPath: '/offer'
      preLoaderRoute: typeof SignupOfferIndexRouteImport
      parentRoute: typeof SignupRoute
    }
    '/_signup/gym/': {
      id: '/_signup/gym/'
      path: '/gym'
      fullPath: '/gym'
      preLoaderRoute: typeof SignupGymIndexRouteImport
      parentRoute: typeof SignupRoute
    }
    '/_signup/status/$statusScreen': {
      id: '/_signup/status/$statusScreen'
      path: '/status/$statusScreen'
      fullPath: '/status/$statusScreen'
      preLoaderRoute: typeof SignupStatusStatusScreenRouteImport
      parentRoute: typeof SignupRoute
    }
    '/_signup/gym/tax-details': {
      id: '/_signup/gym/tax-details'
      path: '/gym/tax-details'
      fullPath: '/gym/tax-details'
      preLoaderRoute: typeof SignupGymTaxDetailsRouteImport
      parentRoute: typeof SignupRoute
    }
    '/_signup/gym/business-details': {
      id: '/_signup/gym/business-details'
      path: '/gym/business-details'
      fullPath: '/gym/business-details'
      preLoaderRoute: typeof SignupGymBusinessDetailsRouteImport
      parentRoute: typeof SignupRoute
    }
    '/opportunity/$oppId/terms-and-conditions/': {
      id: '/opportunity/$oppId/terms-and-conditions/'
      path: '/terms-and-conditions'
      fullPath: '/opportunity/$oppId/terms-and-conditions'
      preLoaderRoute: typeof OpportunityOppIdTermsAndConditionsIndexRouteImport
      parentRoute: typeof OpportunityOppIdRouteRoute
    }
    '/opportunity/$oppId/success/': {
      id: '/opportunity/$oppId/success/'
      path: '/success'
      fullPath: '/opportunity/$oppId/success'
      preLoaderRoute: typeof OpportunityOppIdSuccessIndexRouteImport
      parentRoute: typeof OpportunityOppIdRouteRoute
    }
    '/opportunity/$oppId/email-validation/': {
      id: '/opportunity/$oppId/email-validation/'
      path: '/email-validation'
      fullPath: '/opportunity/$oppId/email-validation'
      preLoaderRoute: typeof OpportunityOppIdEmailValidationIndexRouteImport
      parentRoute: typeof OpportunityOppIdRouteRoute
    }
    '/_signup/offer/decline/': {
      id: '/_signup/offer/decline/'
      path: '/offer/decline'
      fullPath: '/offer/decline'
      preLoaderRoute: typeof SignupOfferDeclineIndexRouteImport
      parentRoute: typeof SignupRoute
    }
    '/opportunity/$oppId/terms-and-conditions/decline/': {
      id: '/opportunity/$oppId/terms-and-conditions/decline/'
      path: '/terms-and-conditions/decline'
      fullPath: '/opportunity/$oppId/terms-and-conditions/decline'
      preLoaderRoute: typeof OpportunityOppIdTermsAndConditionsDeclineIndexRouteImport
      parentRoute: typeof OpportunityOppIdRouteRoute
    }
    '/opportunity/$oppId/terms-and-conditions/decline/success/': {
      id: '/opportunity/$oppId/terms-and-conditions/decline/success/'
      path: '/terms-and-conditions/decline/success'
      fullPath: '/opportunity/$oppId/terms-and-conditions/decline/success'
      preLoaderRoute: typeof OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRouteImport
      parentRoute: typeof OpportunityOppIdRouteRoute
    }
  }
}

interface SignupRouteChildren {
  SignupActivitiesRoute: typeof SignupActivitiesRoute
  SignupEmailValidationRoute: typeof SignupEmailValidationRoute
  SignupPricingRoute: typeof SignupPricingRoute
  SignupSuccessRoute: typeof SignupSuccessRoute
  SignupGymBusinessDetailsRoute: typeof SignupGymBusinessDetailsRoute
  SignupGymTaxDetailsRoute: typeof SignupGymTaxDetailsRoute
  SignupStatusStatusScreenRoute: typeof SignupStatusStatusScreenRoute
  SignupGymIndexRoute: typeof SignupGymIndexRoute
  SignupOfferIndexRoute: typeof SignupOfferIndexRoute
  SignupStatusIndexRoute: typeof SignupStatusIndexRoute
  SignupOfferDeclineIndexRoute: typeof SignupOfferDeclineIndexRoute
}

const SignupRouteChildren: SignupRouteChildren = {
  SignupActivitiesRoute: SignupActivitiesRoute,
  SignupEmailValidationRoute: SignupEmailValidationRoute,
  SignupPricingRoute: SignupPricingRoute,
  SignupSuccessRoute: SignupSuccessRoute,
  SignupGymBusinessDetailsRoute: SignupGymBusinessDetailsRoute,
  SignupGymTaxDetailsRoute: SignupGymTaxDetailsRoute,
  SignupStatusStatusScreenRoute: SignupStatusStatusScreenRoute,
  SignupGymIndexRoute: SignupGymIndexRoute,
  SignupOfferIndexRoute: SignupOfferIndexRoute,
  SignupStatusIndexRoute: SignupStatusIndexRoute,
  SignupOfferDeclineIndexRoute: SignupOfferDeclineIndexRoute,
}

const SignupRouteWithChildren =
  SignupRoute._addFileChildren(SignupRouteChildren)

interface OpportunityOppIdRouteRouteChildren {
  OpportunityOppIdEmailValidationIndexRoute: typeof OpportunityOppIdEmailValidationIndexRoute
  OpportunityOppIdSuccessIndexRoute: typeof OpportunityOppIdSuccessIndexRoute
  OpportunityOppIdTermsAndConditionsIndexRoute: typeof OpportunityOppIdTermsAndConditionsIndexRoute
  OpportunityOppIdTermsAndConditionsDeclineIndexRoute: typeof OpportunityOppIdTermsAndConditionsDeclineIndexRoute
  OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRoute: typeof OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRoute
}

const OpportunityOppIdRouteRouteChildren: OpportunityOppIdRouteRouteChildren = {
  OpportunityOppIdEmailValidationIndexRoute:
    OpportunityOppIdEmailValidationIndexRoute,
  OpportunityOppIdSuccessIndexRoute: OpportunityOppIdSuccessIndexRoute,
  OpportunityOppIdTermsAndConditionsIndexRoute:
    OpportunityOppIdTermsAndConditionsIndexRoute,
  OpportunityOppIdTermsAndConditionsDeclineIndexRoute:
    OpportunityOppIdTermsAndConditionsDeclineIndexRoute,
  OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRoute:
    OpportunityOppIdTermsAndConditionsDeclineSuccessIndexRoute,
}

const OpportunityOppIdRouteRouteWithChildren =
  OpportunityOppIdRouteRoute._addFileChildren(
    OpportunityOppIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SignupRoute: SignupRouteWithChildren,
  OpportunityOppIdRouteRoute: OpportunityOppIdRouteRouteWithChildren,
  StartBusinessTypeRoute: StartBusinessTypeRoute,
  StartOthersRoute: StartOthersRoute,
  OpportunityIndexRoute: OpportunityIndexRoute,
  StartIndexRoute: StartIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
